import React, { useContext } from 'react';
import { Box } from '@material-ui/core';
import { isNullOrUndefined } from 'util';
import { ApplicationContext, AppContext } from '../../context/Contexts';
import { useAppSelector } from '../../store/configureStore';
import { useStyles } from '../../custom-forms';
import { Utils } from '../../helpers/Utils';
import { IReferential } from '../../interfaces/IReferential';
import { Order, OrderTotals } from '../../interfaces/Order';

export interface OrderDetailsTotalsProps {
  order: Order;
  tva: number;
  currencyCode: string | null;
}

const OrderDetailsTotals: React.FC<OrderDetailsTotalsProps> = ({ order, tva, currencyCode }) => {
  const context = useContext(ApplicationContext) as AppContext;
  const classes = useStyles();
  const translatorService = context.translatorService;
  const country = useAppSelector(
    (s) => (s.app?.appUser?.organization?.country ?? null) as IReferential | null
  );

  const currencySuffix =
    !isNullOrUndefined(currencyCode) && currencyCode !== '' ? currencyCode : '';
  const tvaLabel = tva ? tva.toFixed(0) : '';

  return (
    <Box mb={2} style={{ backgroundColor: '#FFFFFF', borderRadius: 8, overflow: 'hidden' }}>
      <Box className={classes.sectionHeader}>
        {translatorService.Tranlate('ORDER_DETAILS_TOTAL_TITLE', 'TOTAL COMANDA')}
      </Box>
      <Box p={2}>
        <Box>
          <b>
            {translatorService.Tranlate('ORDER_DETAILS_TOTAL_NO_TVA_LABEL', 'Total fara TVA') +
              ': '}
          </b>
          {Utils.countryNumberFormat(order.amountWithoutTVA.toFixed(2), country) +
            ' ' +
            currencySuffix}
        </Box>
        <Box>
          <b>
            {translatorService.Tranlate('ORDER_DETAILS_TVA_LABEL', 'TVA')}
            {tvaLabel !== '' ? ' (' + tvaLabel + '%)' : ''}
            {': '}
          </b>
          {Utils.countryNumberFormat(order.amountTVA.toFixed(2), country) + ' ' + currencySuffix}
        </Box>
        <Box>
          <b>{translatorService.Tranlate('ORDER_DETAILS_TOTAL_LABEL', 'Total') + ': '}</b>
          {Utils.countryNumberFormat(order.amount.toFixed(2), country) + ' ' + currencySuffix}
        </Box>
      </Box>
    </Box>
  );
};

export default OrderDetailsTotals;
